import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KEY_DEFAULT_ERROR } from 'src/app/model/error.model';
import { CidaasService } from 'src/app/service/cidaas.service';
import { CommonFunctionsService } from 'src/app/service/common-functions.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { getTranslationKeyByVerificationMediumString } from '../../../model/domain/verification.model';
import { ResetPasswordRequest } from '../../../model/reset-password-request.interface';

@Component({
  selector: 'app-forgot-password-init',
  templateUrl: './forgot-password-init.component.html',
  styleUrls: ['./forgot-password-init.component.scss'],
})
export class ForgotPasswordInitComponent implements OnInit {
  requestId = '';
  username = '';
  resetMedium = '';
  configuredMFAList: any = [];
  showCode = false;
  inputGroupOption = {
    input: {
      label: 'ENTER_VERIFICATION_CODE',
      placeholder: 'ENTER_VERIFICATION_CODE',
      type: 'input',
      hint: '',
      value: '',
      error: '',
    },
    button: {
      text: 'LOGIN.CLASSICAL_LOGIN.BUTTON.TEXT',
      color: 'accent',
      iconClass: 'cidaas-icon-push',
      showImg: false,
    },
  };
  buttonOptions: any = {
    resetButtonOption: {
      text: 'RESET_PASSWORD',
      color: 'accent',
      fullWidth: true,
      type: 'proceed',
      underline: 'none',
    },
  };
  code = '';
  rprq = '';
  showBack = true;
  // TODO: Remove resetInitiatePayload state all together
  resetInitiatePayload: {
    requestId?: string;
    resetMedium?: string;
    processingType?: 'CODE';
    email?: string;
    username?: string;
    mobile?: string;
  } = {};
  errorMessage = '';
  contentLoading = false;
  submissionInProgress = false;
  resetMediumTranslation = '';
  constructor(
    private activatedRoute: ActivatedRoute,
    private dataService: SharedDataService,
    private cidaasService: CidaasService,
    private router: Router,
    public commonFunc: CommonFunctionsService
  ) {}

  ngOnInit(): void {
    this.requestId = this.activatedRoute.snapshot.queryParams.requestId || this.activatedRoute.snapshot.queryParams.requestid;
    this.username = this.activatedRoute.snapshot.queryParams.userIdHint;
    this.resetInitiatePayload.resetMedium = '';
    this.errorMessage = this.activatedRoute.snapshot.queryParams.error;
    if (this.errorMessage) {
      this.errorMessage = this.errorMessage.toUpperCase();
    }
    this.rprq = this.activatedRoute.snapshot.queryParams.rprq;
    if (this.rprq) {
      this.showCode = true;
      this.showBack = false;
    }
    this.resetMedium = this.activatedRoute.snapshot.queryParams.type;
    if (this.activatedRoute.snapshot.queryParams.resetMedium) {
      this.resetMedium = this.activatedRoute.snapshot.queryParams.resetMedium;
      this.resetInitiatePayload.resetMedium = this.resetMedium;
    } else {
      this.resetMedium = this.activatedRoute.snapshot.queryParams.type;
    }
    if (this.resetMedium) {
      this.resetMediumTranslation = getTranslationKeyByVerificationMediumString(this.resetMedium);
    }

    // not getting the mfa list from the service, hence making the api call
    this._getMFAList();
  }

  // on entering verification code and submitting, verify the entered code
  submitCode(): void {
    if (this.code) {
      const resetAuthenticatePayload = { resetRequestId: this.rprq, code: this.code };
      this.submissionInProgress = true;
      this.cidaasService.handleResetPassword(resetAuthenticatePayload);
    } else {
      this.inputGroupOption.input.error = 'REQUIRED_FIELD';
    }
  }

  // update code from input groups input event
  updateCode(code): void {
    this.code = code;
    this.inputGroupOption.input.value = code;
  }

  // on click of reset button, initiates reset for username/mobile/email
  initiateReset(): void {
    this.resetInitiatePayload = {
      requestId: this.requestId,
      processingType: 'CODE',
      resetMedium: '',
    };
    this.populateResetPayload();
    this.contentLoading = true;
    this.errorMessage = '';
    this.cidaasService
      // TODO: Make resetInitiatePayload immutable
      .initiatePasswordReset(this.resetInitiatePayload as ResetPasswordRequest)
      .then((data) => {
        this.contentLoading = false;
        if (data && data.success && data.data?.reset_initiated && data.status === 200) {
          this.showCode = true;
          this.rprq = data.data.rprq;
        } else {
          if(!data.data?.reset_initiated){
            this.errorMessage = 'LOGIN.AUTHENTICATION.NO_AUTHENTICATION_METHODS_FOUND'
          }else{
            this.errorMessage = 'ERROR.MSG';
          }
        }
      })
      .catch(() => {
        this.errorMessage = 'ERROR.MSG';
      });
  }

  populateResetPayload(): void {
    switch (this.resetMedium) {
      case 'user_name':
        this.resetInitiatePayload.username = this.username;
        if (this.configuredMFAList?.length > 0) {
          this.resetInitiatePayload.resetMedium = this.getResetMedium();
        } else {
          this.resetInitiatePayload.resetMedium = 'email';
        }
        break;
      case 'email':
        this.resetInitiatePayload.email = this.username;
        this.resetInitiatePayload.resetMedium = 'email';
        break;
      case 'mobile':
        this.resetInitiatePayload.mobile = this.username;
        this.resetInitiatePayload.resetMedium = 'sms';
        break;
      default:
        this.resetInitiatePayload[this.resetMedium ? this.resetMedium : this.activatedRoute.snapshot.queryParams.type] = this.username;
        if (this.configuredMFAList?.length > 0) {
          this.resetInitiatePayload.resetMedium = this.getResetMedium();
        } else {
          this.resetInitiatePayload.resetMedium = 'email';
        }
    }
    // TODO: Properly return the payload instead of void
    this.resetMediumTranslation = getTranslationKeyByVerificationMediumString(this.resetInitiatePayload.resetMedium);
  }

  getResetMedium(): string {
    let resetMedium = '';
    if (this.configuredMFAList.findIndex((x) => x.type === 'EMAIL') > -1) {
      resetMedium = 'email';
    } else if (this.configuredMFAList.findIndex((x) => x.type === 'SMS') > -1) {
      resetMedium = 'sms';
    } else if (this.configuredMFAList.findIndex((x) => x.type === 'IVR') > -1) {
      resetMedium = 'ivr';
    }
    return resetMedium;
  }

  cancelReset(): void {
    this.showCode = false;
  }

  backToInitiate(): void {
    this.router.navigate(['login/initiate'], {
      queryParams: {
        userIdHint: this.username,
        requestId: this.requestId,
        type: this.resetMedium,
      },
    });
  }

  // funtion to get the configured mfa list
  _getMFAList = () => {
    let options = {};
    options['request_id'] = this.requestId;
    switch (this.resetMedium) {
      case 'user_name': {
        options['username'] = this.username;
        break;
      }
      case 'mobile': {
        options['mobile_number'] = this.username;
        break;
      }
      default: {
        options[this.resetMedium] = this.username;
        break;
      }
    }
    this.cidaasService
      ._getMFAList(options)
      .then((response) => {
        if (response && response.data) {
          this.dataService._setMFAList(response.data);
          this.configuredMFAList = response.data?.configured_list;
        } else if (response.error) {
          if (response.error.error === 'not able to find user sub') {
            this.errorMessage = 'NO_USER_FOUND';
          } else if (response.error.code === 10028) {
            this.errorMessage = 'IP_BLOCKED';
          } else {
            this.errorMessage = KEY_DEFAULT_ERROR;
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
